import { Button } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import AvatarMenu from './AvatarMenu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import pkg from '../../package.json';

const Header = () => {
  const navigate = useNavigate();
  const [avatarMenuAnchorEl, setAvatarMenuAnchorEl] =
    useState<null | HTMLElement>(null);
  const isAvatarMenuOpen = Boolean(avatarMenuAnchorEl);

  const openAvatarMenu = (event: MouseEvent<HTMLElement>) => {
    setAvatarMenuAnchorEl(event.currentTarget);
  };
  const closeAvatarMenu = () => {
    setAvatarMenuAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          boxShadow: 'none',
          zIndex: 100,
          top: 0,
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          px: { xs: 1.5, sm: 2, md: 4 },
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 2 },
            height: 72,
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            onClick={() => navigate('/')}
            sx={{
              cursor: 'pointer',
              flex: '1 1 auto',
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              lineHeight: { xs: 1.3, lg: 1.167 },
            }}
          >
            Question Authoring Platform 2.0
          </Typography>

          <IconButton
            aria-label="support"
            sx={{ flexShrink: 0 }}
            onClick={openAvatarMenu}
          >
            <AccountCircle sx={(theme) => ({ fill: theme.palette.common.white })} />
          </IconButton>

          {/*Profile Menu*/}
          <AvatarMenu
            open={isAvatarMenuOpen}
            anchorEl={avatarMenuAnchorEl}
            onClose={closeAvatarMenu}
          />

        </Toolbar>
      </AppBar>

      {/* version display icon */}
      <Typography
        component="div"
        variant="caption"
        sx={{ position: 'fixed', zIndex: 1, left: 12, bottom: 0 }}
      >
        <Button>v{pkg.version}</Button>
      </Typography>
    </>
  );
};

export default Header;
